import React from 'react';
import { useConfiguration } from '../../context/configurationContext';
import CtFooter from './CtFooter';

// Container Trader: custom footer. Slogan, copyright and social links still come from the
// Console footer settings; the link columns are set in CtFooter.js.
const FooterComponent = () => {
  const { footer = {}, topbar } = useConfiguration();

  // If footer asset is not set, let's not render Footer at all.
  if (Object.keys(footer).length === 0) {
    return null;
  }

  return <CtFooter footer={footer} linkLogoToExternalSite={topbar?.logoLink} />;
};

export default FooterComponent;
